import { render } from "./Cates.vue?vue&type=template&id=3b4a1c5b&scoped=true"
import script from "./Cates.vue?vue&type=script&lang=js"
export * from "./Cates.vue?vue&type=script&lang=js"

import "./Cates.vue?vue&type=style&index=0&id=3b4a1c5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4a1c5b"]])

export default __exports__